module.exports = __webpack_public_path__ + "img/seo.c777001.svg";